<template>
  <div class="popup__block">
    <div class="popup__title">Восстановление пароля</div>
    <div class="popup-review">
      <div v-if="mes">
        <center><p>{{ mes }}</p></center>
      </div>
      <br/>
      <form @submit.prevent="debounce(validate)" class="form">
        <div class="form__inputs">
          <div class="default-input">
            <input @input="this.reset" v-model="email" autocomplete="off" class="default-input__input" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 5)}" type="text" placeholder="E-mail">
            <span v-if="errors.some(er => er.code === 5)" class="default-input__error"></span>
          </div>
        </div>
        <div style="display: none">
          <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="sendData" @expired="onCaptchaExpired"/>
        </div>
        <div v-if="showBtn" class="form__submit">
          <input class="btn btn--mini" type="submit" value="Восстановить пароль"/>
          <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие на
            <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import recaptcha  from "@/components/mixins/recaptcha";
import errors     from "@/components/mixins/errors";
import tools      from "@/components/mixins/tools";
import {mapState} from "vuex";

export default {
  name : "ForgotForm",
  data()
  {
    return {
      email   : "",
      mes     : "",
      showBtn : true
    };
  },
  computed : {
    ...mapState([
      "modulePolicy"
    ])
  },
  mixins   : [recaptcha, errors, tools],
  methods  : {
    sendData( recaptchaToken )
    {
      this.reset();
      let formData = new FormData();
      formData.append("email", this.email);
      formData.append("token", recaptchaToken);
      fetch("/api/user/auth/forgot/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success !== true)
        {
          this.mes = "";
          let errs = JSON.parse(resp.message);
          this.parse(errs);
          this.code_sent = !errors.some(er => er.code === 13);
        }
        else
        {
          this.reset();
          if(resp.data)
          {
            this.mes = resp.data.mes;
          }
          this.showBtn = false;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>